import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function TCGNotification$Type$Companion$_anonymous__qy0drg() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.TCGNotification.Type', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Type_ProviderSubmittedAttendance_instance = new (Type())('ProviderSubmittedAttendance', 0, 'Attendance period submitted');
  Type_TCGApprovedAttendance_instance = new (Type())('TCGApprovedAttendance', 1, 'Attendance period approved');
  Type_AttendanceSubmissionReminder_instance = new (Type())('AttendanceSubmissionReminder', 2, 'Attendance submission reminder');
  Type_PlacementExpiring_instance = new (Type())('PlacementExpiring', 3, 'Child placement expiring');
  Type_FamilyApplicationSubmitted_instance = new (Type())('FamilyApplicationSubmitted', 4, 'Family application submitted');
  Type_ProviderApplicationSubmitted_instance = new (Type())('ProviderApplicationSubmitted', 5, 'Provider application submitted');
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Type_ProviderSubmittedAttendance_instance;
var Type_TCGApprovedAttendance_instance;
var Type_AttendanceSubmissionReminder_instance;
var Type_PlacementExpiring_instance;
var Type_FamilyApplicationSubmitted_instance;
var Type_ProviderApplicationSubmitted_instance;
function values() {
  static_init();
  return [Type_ProviderSubmittedAttendance_getInstance(), Type_TCGApprovedAttendance_getInstance(), Type_AttendanceSubmissionReminder_getInstance(), Type_PlacementExpiring_getInstance(), Type_FamilyApplicationSubmitted_getInstance(), Type_ProviderApplicationSubmitted_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, TCGNotification$Type$Companion$_anonymous__qy0drg);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var $ENTRIES;
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
      eventName_ilcg5_k$() {
        return this.name_1;
      }
    }
    initMetadataForClass($, 'Type', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    TypeClass = $;
  }
  return TypeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.TCGNotification', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('subject', false);
        tmp0_serialDesc.addElement_5pzumi_k$('body', false);
        tmp0_serialDesc.addElement_5pzumi_k$('url', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_mye6eg_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.subject_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.body_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.url_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, StringSerializer_getInstance(), value.url_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_mye6eg_k$(encoder, value instanceof TCGNotification() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return TCGNotification().new_org_thecommunitygroupinc_cares_TCGNotification_c25wpy_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Type_ProviderSubmittedAttendance_getInstance() {
  static_init();
  return Type_ProviderSubmittedAttendance_instance;
}
function Type_TCGApprovedAttendance_getInstance() {
  static_init();
  return Type_TCGApprovedAttendance_instance;
}
function Type_AttendanceSubmissionReminder_getInstance() {
  static_init();
  return Type_AttendanceSubmissionReminder_instance;
}
function Type_PlacementExpiring_getInstance() {
  static_init();
  return Type_PlacementExpiring_instance;
}
function Type_FamilyApplicationSubmitted_getInstance() {
  static_init();
  return Type_FamilyApplicationSubmitted_instance;
}
function Type_ProviderApplicationSubmitted_getInstance() {
  static_init();
  return Type_ProviderApplicationSubmitted_instance;
}
var TCGNotificationClass;
function TCGNotification() {
  if (TCGNotificationClass === VOID) {
    class $ {
      constructor(subject, body, url) {
        url = url === VOID ? null : url;
        this.subject_1 = subject;
        this.body_1 = body;
        this.url_1 = url;
      }
      toString() {
        return 'TCGNotification(subject=' + this.subject_1 + ', body=' + this.body_1 + ', url=' + this.url_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.subject_1);
        result = imul(result, 31) + getStringHashCode(this.body_1) | 0;
        result = imul(result, 31) + (this.url_1 == null ? 0 : getStringHashCode(this.url_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TCGNotification()))
          return false;
        if (!(this.subject_1 === other.subject_1))
          return false;
        if (!(this.body_1 === other.body_1))
          return false;
        if (!(this.url_1 == other.url_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_TCGNotification_c25wpy_k$(seen0, subject, body, url, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.subject_1 = subject;
        $this.body_1 = body;
        if (0 === (seen0 & 4))
          $this.url_1 = null;
        else
          $this.url_1 = url;
        return $this;
      }
    }
    initMetadataForClass($, 'TCGNotification', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    TCGNotificationClass = $;
  }
  return TCGNotificationClass;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_instance_1 as Companion_instance9ofeumbwb97p,
  get_entries as get_entriesmw6968mpe3hf,
  TCGNotification as TCGNotification15rsix3sbs9g0,
};
//endregion

//# sourceMappingURL=notifications.mjs.map
